module.exports = __webpack_public_path__ + "static/media/paragon_2.7f5c5aeb.png";